import React from 'react';
import PropTypes from 'prop-types';

import DocumentStoreItem from '../../models/document_store_item';
import DocumentModalIds from '../../constants/document_modal_ids';
import { DocumentActions } from '../../reflux/document_store';
import { ProcessAPI } from 'lecom-api';

const RealizeFlash = window.Flash;

export default class DetachDocumentModal extends React.Component {

	static propTypes = {
		id: PropTypes.string,
		name: PropTypes.string,
		title: PropTypes.string,
		className: PropTypes.string,
		store: PropTypes.object
	};

	static defaultProps = {
		id: '',
		name: '',
		title: 'template.titles.detach',
		className: 'detach-document-modal',
		store: new DocumentStoreItem()
	};

	constructor(props) {
		super(props);
	}

	get document() {
		return this.props.store.document;
	}

	get gridData() {
		return this.props.store.gridData;
	}

	get waitingForAction() {
		return this.props.store.waitingForAction;
	}

	onFocusDetachDocumentModal(){
		setTimeout(() => {
			let modal = $('#documentModal');
			let btnCloseModal = $('.button-close-modal-document');
			let btnDetachDoc = $('.button-detach-document');
			let btnDeleteDoc = $('.button-delete-document');

			modal.keydown((e) => {
				if(e.which ===  27){
					btnCloseModal[0].click();
				}
			});

			btnCloseModal.attr("tabindex",-1);
			modal.find('.h5-custom').focus();

			btnCloseModal.attr('tabindex', '0');
			btnCloseModal.keydown((e) => {
				e.which === 13 ? e.currentTarget.click() : '';

				if(e.shiftKey && e.keyCode === 9){
					modal.find('.h5-custom').focus();
					return false
				}
			});

			btnDetachDoc.attr('tabindex', '0');

			btnDetachDoc.keydown((e) => {
				let btnDeleteDocIsVisible = $('.button-delete-document').is(':visible');

				if(btnDeleteDocIsVisible === false){
					if(e.which === 9 || e.keyCode === 9 ){
						modal.find('.h5-custom').focus();
						return false
					}
				}
			});

			if(btnDeleteDoc.length > 0){
				btnDeleteDoc.attr("tabindex", 0);

				btnDeleteDoc.keydown((e) => {
					if(e.shiftKey){
						if(e.shiftKey && e.keyCode === 9)
							return true
					}

					if(e.which === 9 || e.keyCode === 9 ){
						modal.find('.h5-custom').focus();
						return false
					}
				});
			}
		}, 1000)
	}

	documentCanBeDeleted() {
		return this.props.store.documentCanBeDeleted;
	}

	renderGridDocumentInfoFlash() {
		if (!!this.gridData.rowIndex)
			return (
			<div style={{marginBottom: '0px'}} className="row">
			<RealizeFlash message={Realize.i18n.t('template.messages.gridDetachModal')} canDismiss={false} />
			</div>
		);
	}

	onFocusDocumentCanBeDeleted(){
		setTimeout(() => {
			let buttonDelete = $('.button-delete-document');
			buttonDelete.attr('tabindex', '0');

			buttonDelete.keydown((e) => {
				if(e.which === 9){
					$('.button-close-modal-document')[0].focus();
					return false
				} else if(e.which === 13){
					e.currentTarget.click();
				}
			})
		}, 1000);
	}

	render() {
		this.onFocusDetachDocumentModal();

		const currentProcess = ProcessAPI.currentProcess();
		var message = "";

		if (currentProcess.isPublic()) {
			if (this.documentCanBeDeleted()) {
				message = Realize.i18n.t('template.messages.delete');

				this.onFocusDocumentCanBeDeleted();
			} else {
				message = Realize.i18n.t('template.messages.detach');
			}
		} else {
			message = this.documentCanBeDeleted()
			? Realize.i18n.t('template.messages.detachOrDelete')
			: Realize.i18n.t('template.messages.detach');
		}

		return (
			<div>
				{ this.renderGridDocumentInfoFlash() }
				<h6 tabIndex="0">{message}</h6>
			</div>
		);
	}
}
